import { inject, Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { catchError, defer, finalize, Observable, of } from 'rxjs';
import { LoadingState } from '../../../../../shared/types/loading.type';
import { ToastService } from '@ui-lib/components';
import { TranslateService } from '@ngx-translate/core';
import { outputError } from '../../../../../shared/utils/output-error.function';
import { DashboardClient } from '../../../../../core/openapi/bff-admin-api/api/dashboard.client';
import { FacilityMetricTableRow } from './overview-dashboard-modal.model';

@Injectable()
export class OverviewDashboardModalService {
  private readonly dashboardClient = inject(DashboardClient);
  private readonly toastService = inject(ToastService);
  private readonly translateService = inject(TranslateService);

  private readonly _loadingStatus: WritableSignal<LoadingState> = signal<LoadingState>(
    LoadingState.IDLE,
  );
  public readonly loadingStatus: Signal<LoadingState> = this._loadingStatus.asReadonly();

  public readonly facilityMetrics$: Observable<FacilityMetricTableRow[]> = defer(() => {
    this._loadingStatus.set(LoadingState.LOADING);
    return this.dashboardClient.v1DashboardMetricsByFacilityGet();
  }).pipe(
    catchError((error) => {
      this.toastService.error({
        message: this.translateService.instant(
          'monitoring.dashboard.overview-dashboard.toast.facility-metrics-featcing-faild',
          { error: outputError(error, this.translateService.instant('errors.unknown')) },
        ),
      });
      return of([]);
    }),
    finalize(() => this._loadingStatus.set(LoadingState.READY)),
  );
}
